export enum ModalMode {
  Create = 'create',
  Update = 'update',
  ReadOnly = 'readOnly',
}
